export const getSelectedSubscriptionPlan = (state) => {
  return state.payment.subscriptionPlans.find((plan) => plan.id === state.payment.selectedPlan);
};
